import { useDarkMode } from '../context/DarkModeContext';

export const useAppDarkMode = () => {
  const { isDarkMode } = useDarkMode();
  return { darkMode: isDarkMode };
};